module.exports = __webpack_public_path__ + "img/BlinkArt_Sword3_Green.7096bda1.png";